export type LeadStatus = 'NEW' | 'CONTACTED' | 'SCHEDULED' | 'WON' | 'LOST';

export const LEAD_STATUSES: LeadStatus[] = ['NEW', 'CONTACTED', 'SCHEDULED', 'WON', 'LOST'];

export const LEAD_INTERESTS = [
  'PV_ANLAGE',
  'WECHSELRICHTER',
  'SPEICHER',
  'WALLBOX',
  'BALKONKRAFTWERK',
  'WARTUNG',
  'SONSTIGES',
] as const;

export type LeadInterest = (typeof LEAD_INTERESTS)[number];

export interface Lead {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  street: string | null;
  postalCode: string | null;
  city: string | null;
  availability: string | null;
  preferredAt: string | null;
  interest: LeadInterest | null;
  message: string | null;
  locale: string;
  status: LeadStatus;
  source: string;
  consent: boolean;
  notifiedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface LeadNote {
  id: string;
  body: string;
  createdAt: string;
  author: { id: string; name: string } | null;
}

export type LeadDetail = Lead & { notes: LeadNote[] };

export interface LeadStats {
  total: number;
  byStatus: Record<LeadStatus, number>;
  last7Days: number;
  last30Days: number;
  trend: Array<{ date: string; count: number }>;
}

export interface ContentItem {
  id: string;
  slug: string;
  icon: string;
  titleDe: string;
  titleEn: string;
  bodyDe: string;
  bodyEn: string;
  sortOrder: number;
  isPublished: boolean;
}

export interface Project {
  id: string;
  slug: string;
  titleDe: string;
  titleEn: string;
  descriptionDe: string;
  descriptionEn: string;
  location: string | null;
  sizeKwp: string | null;
  completedAt: string | null;
  componentsDe: string | null;
  componentsEn: string | null;
  imageUrl: string | null;
  videoUrl: string | null;
  sortOrder: number;
  isPublished: boolean;
}

export interface PublicContent {
  services: ContentItem[];
  steps: ContentItem[];
  settings: Record<string, string>;
}

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: 'ADMIN' | 'EDITOR';
  isActive: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  pageCount: number;
}
